import { AgencyType } from "@intelligems/ig-types/dtos/agency-types";
import { OrganizationAgencyLinkDto } from "@intelligems/ig-types/dtos/organization-agency-links";

export const isBillableAgencyLink = (link: OrganizationAgencyLinkDto) =>
  link.agencyType === "agency";

// "agency" (managed billing) and "aggregator" both put the brand on the
// agency's shared plan, so billing artifacts like coupons can sit on a sibling
// brand's subscription and still apply to this brand. Only
// "agency_self_billing" brands own their subscription directly and bill
// independently. Mirrors the backend's guard in
// organization-agency-links.controller.ts.
export const isSharedPlanAgencyLink = (link: OrganizationAgencyLinkDto) =>
  link.agencyType != null && link.agencyType !== "agency_self_billing";

// agency_self_billing is excluded: those orgs own their Stripe subscription
// directly and are not billed through the agency, so the link carries no
// billing meaning in agency-facing UIs.
// When a new AgencyType is added, decide here whether it should be visible.
const VISIBLE_AGENCY_TYPES = new Set<AgencyType>(["agency", "aggregator"]);

export const isVisibleAgencyLink = (link: OrganizationAgencyLinkDto) =>
  link.agencyType != null && VISIBLE_AGENCY_TYPES.has(link.agencyType);

export const getCreateSubscriptionAgencyNavigationLink = (
  links: OrganizationAgencyLinkDto[] | undefined
): OrganizationAgencyLinkDto | undefined => {
  return (
    links?.find(isBillableAgencyLink) ??
    links?.find(isVisibleAgencyLink) ??
    links?.[0]
  );
};

export const getModifySubscriptionAgencyNavigationLink = (
  links: OrganizationAgencyLinkDto[] | undefined
): OrganizationAgencyLinkDto | undefined => {
  return links?.find(isBillableAgencyLink);
};

export const getAgencyIconTooltip = (
  link: OrganizationAgencyLinkDto
): string => {
  const name = link.name;
  if (link.agencyType === "aggregator") {
    return name ? `Part of ${name} group plan` : "Part of group plan";
  }
  return name ? `Part of ${name} agency` : "Part of agency";
};
